import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles({
  root: {
    color: "darkgrey",
    padding: 0,
    // marginTop: 12,
    marginLeft: 10,
    backgroundColor: "black",
    width: 16,
    // height: 16,
  },
});

export const tableCellStyle = {
  width: "40%",
  padding: "2px 6px 2px 6px",
  color: "white",
  textAlign: "center",
  height: "auto !important",
  backgroundColor: "#505050",
};



// WEBPACK FOOTER //
// ./src/Pages/OptionsBoard/index.style.js